import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgEmailSend({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M3.424 9.65v3.294a.31.31 0 00.322.33.925.925 0 00.644-.33l1.29-1.317-2.256-1.976zm0-.328S1.789 8.079.844 7.346C.375 6.98.522 6.71.522 6.71s-.003-.143.644-.352c2.34-.755 10.773-3.453 13.535-4.28.581-.175.645 0 .645 0L3.424 9.321zm5.156 3.951s-.139.095-.644-.329c-1.137-.952-3.867-3.293-3.867-3.293l11.277-7.574a.43.43 0 010 .66c-1.502 1.842-5.104 8.474-6.121 10.207a.632.632 0 01-.646.33z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgEmailSend.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgEmailSend.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgEmailSend svgRef={ref} {...props} />);
export default ForwardRef;
